import { inject } from "@angular/core";
import { AuthenticationService } from "@app/core/services/authentication.service";
import { WC_APPLICATIONS } from "@app/portals/wc-modules/wc-shared/constants/applications.constants";
import { WC_PORTALS } from "@app/portals/wc-modules/wc-shared/constants/portal-constants";

export const WcGuard = () => {
  const authService = inject(AuthenticationService);

  // Check for valid application and  portal
  const application = authService.applicationId === WC_APPLICATIONS.WC;
  const portal = [WC_PORTALS.AGENT, WC_PORTALS.MEMBER].find((x) => x === authService.moduleId);

  if (!application || !portal) {
    return false;
  }
  return true;
};
